import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./TeamBottomNav.css";

const HomeIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="m3 10 9-7 9 7v9a2 2 0 0 1-2 2h-4v-7H9v7H5a2 2 0 0 1-2-2v-9Z" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const EditIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M12 20h9" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round"/>
    <path d="m16.5 3.5 4 4L8 20H4v-4L16.5 3.5Z" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const HistoryIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M7 3h10a2 2 0 0 1 2 2v16l-7-3-7 3V5a2 2 0 0 1 2-2Z" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const LogoutIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M10 4H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h5" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round"/>
    <path d="m15 8 4 4-4 4M9 12h10" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default function TeamBottomNav({ currentTab, setTab, previewMode = false, onExitPreview }) {
  const [showConfirm, setShowConfirm] = useState(false);
  const navigate = useNavigate();

  const items = [
    { key: "overview", label: "หน้าหลัก", icon: <HomeIcon /> },
    { key: "tracker", label: "กรอกค่ากด", icon: <EditIcon /> },
    { key: "history", label: "ประวัติ", icon: <HistoryIcon /> },
  ];

  const confirmLogout = () => {
    setShowConfirm(false);
    navigate("/logout");
  };

  return (
    <>
      <nav className="team-bottom-nav" aria-label="เมนูทีม">
        <div className="team-bottom-nav__inner">
          {items.map((item) => (
            <button
              type="button"
              key={item.key}
              className={`team-nav-item ${currentTab === item.key ? "active" : ""}`}
              onClick={() => setTab(item.key)}
              aria-current={currentTab === item.key ? "page" : undefined}
            >
              <span className="team-nav-icon">{item.icon}</span>
              <span>{item.label}</span>
            </button>
          ))}

          <button
            type="button"
            className="team-nav-item team-nav-logout"
            onClick={() => {
              if (previewMode) {
                onExitPreview?.();
              } else {
                setShowConfirm(true);
              }
            }}
          >
            <span className="team-nav-icon"><LogoutIcon /></span>
            <span>{previewMode ? "กลับแอดมิน" : "ออก"}</span>
          </button>
        </div>
      </nav>

      {!previewMode && showConfirm && (
        <div className="team-logout-overlay" role="presentation" onMouseDown={() => setShowConfirm(false)}>
          <div className="team-logout-dialog" role="dialog" aria-modal="true" aria-labelledby="team-logout-title" onMouseDown={(e) => e.stopPropagation()}>
            <div className="team-logout-icon"><LogoutIcon /></div>
            <h3 id="team-logout-title">ออกจากระบบ?</h3>
            <p>คุณสามารถกลับมาเข้าสู่ระบบด้วยบัญชีเดิมได้ตลอด</p>
            <div className="team-logout-actions">
              <button type="button" onClick={() => setShowConfirm(false)}>ยกเลิก</button>
              <button type="button" className="danger" onClick={confirmLogout}>ออกจากระบบ</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
